export class RelayBoard {
  id: number;
  name: string;
  relayCount: number;
  host: string;
  port: number;
  officeId: number;

  public constructor(init?: Partial<RelayBoard>) {
    Object.assign(this, init);
  }
}
